import styled from 'styled-components';

export const ChecklistPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const MonthSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const MonthHeader = styled.h3`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const MonthGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
`;

export const ChecklistCard = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid ${props => props.$isUnlocked ? 'rgba(255, 255, 255, 0.33)' : 'rgba(255, 255, 255, 0.33)'};
    border-radius: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    color: inherit;
    cursor: pointer;
    display: block;
    padding: 8px;
    text-decoration: none;
    transition: all 0.3s ease;
    width: 280px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
        border-color: ${props => props.$isUnlocked ? 'rgba(255, 255, 255, 0.67)' : 'rgba(255, 255, 255, 0.2)'};
    }

    ${props => !props.$isUnlocked && `
        opacity: 0.8;
        background: rgba(255, 255, 255, 0.1);
    `}
`;

export const ChecklistCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;


export const ChecklistImage = styled.div`
    width: 100%;
    background-color: blue;
    height: 180px;
    border-radius: 8px;
    overflow: hidden;
    background: var(--panel-bg-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #333;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
        filter: ${props => props.$isLocked ? 'blur(1.5px)' : 'none'};
    }
    
    // Fallback for missing images
    &::before {
        content: '📄';
        font-size: 2rem;
        color: var(--text-color);
        opacity: 0.5;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: ${props => props.$hasImage ? 'none' : 'block'};
    }
`;

export const ChecklistTitle = styled.div`
    align-items: center;
    display: flex;
    height: 48px;
    justify-content: center;
    text-align: center;
    
    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
    }
`;

export const ChecklistDetails = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
`;

export const LockIcon = styled.img`
    width: 20px;
    height: 20px;
    opacity: 0.7;
`;

export const UnlockButton = styled.button`
    align-items: center;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 8px;
    justify-content: center;
    padding: 8px 16px;
    transition: all 0.2s ease;
    width: 100%;

    &:hover:not(:disabled) {
        background: var(--primary-color-dark);
    }

    &:active:not(:disabled) {
        transform: scale(0.95);
    }

    &:disabled {
        background: var(--text-color);
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
`;

export const OpenButton = styled.div`
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 8px;
    justify-content: center;
    padding: 8px 16px;
    transition: all 0.2s ease;
    width: 100%;

    &:hover {
        background: var(--primary-color-dark);
    }

    &:active {
        transform: scale(0.95);
    }
`; 